import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

import QRCode from "qrcode";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import ReactPaginate from "react-paginate";
import apiConfig from "../../../apiConfig";
import "../page.css";
import { useNavigate } from "react-router-dom";
import DropdownOfStatus from "./DropdownOfStatus";
import BackButton from "./BackButton";
import ReactDOM from "react-dom";
import "jspdf-autotable";
import logoImage from "../../../assets/images/icons/shippingLogo.png";

const Accepted = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filterOrderId, setFilterOrderId] = useState("");
  const [filterProductName, setFilterProductName] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [ordersPerPage] = useState(10);
  const tableRef = useRef(null);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedOrder, setSelectedOrder] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [bankDetails, setBankDetails] = useState({}); 
  const [upiId, setUpiId] = useState("");
  const UpiId = localStorage.getItem("UpiId");


  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${apiConfig.baseUrl}${apiConfig.Accepted}`
      );
      setOrders(response.data);
      setFilteredOrders(response.data);
      
      setLoading(false);
    } catch (err) {
      setError("");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    let filtered = orders;

    if (filterOrderId) {
      filtered = filtered.filter((order) =>
        order.orderID.includes(filterOrderId)
      );
    }

    if (filterProductName) {
      filtered = filtered.filter((order) =>
        order.items.some(
          (item) =>
            item.productId &&
            item.productId.title
              .toLowerCase()
              .includes(filterProductName.toLowerCase())
        )
      );
    }

    setFilteredOrders(filtered);
  }, [filterOrderId, filterProductName, orders]);

  const downloadPDF = async () => {
    const input = tableRef.current;
    if (!input) return;

    const canvas = await html2canvas(input, {
      scrollX: 0,
      scrollY: -window.scrollY,
      useCORS: true,
      windowWidth: document.documentElement.scrollWidth,
      windowHeight: document.documentElement.scrollHeight,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const imgWidth = 210;
    const pageHeight = 295;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;

    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save("order_list.pdf");
  };

  const handleRefresh = async () => {
    await fetchOrders();
  };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const handleNavigate = () => {
    navigate("/admin/OrderTracking");
  };

  const handleStatusChange = async (orderID) => {
    setLoading(true);
    try {
      const nextStatus = getNextStatus(selectedStatus);

      if (nextStatus === newStatus) {
        await axios.put(
          `${apiConfig.baseUrl}/admin/order/${orderID}/updateStatus`,
          { status: newStatus }
        );

        await fetchOrders();
        setModalMessage("Order status updated successfully.");
        alert("status updated successfully")
     
      } else {
        console.error("Cannot update to the selected status:", newStatus);
      }
    } catch (err) {
      console.error("Error updating order status:", err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "received":
        return "blue";
      case "processing":
        return "#EF9B0F";
      case "shipped":
        return "green";
      case "delivered":
        return "purple";
      case "cancelled":
        return "#C40233";
      default:
        return "black";
    }
  };

  const getNextStatus = (currentStatus) => {
    switch (currentStatus) {
      case "received":
        return "processing";
      case "processing":
        return "shipped";
      case "shipped":
        return "delivered";
      case "delivered":
        return "";
      case "cancelled":
        return "";
      default:
        return "";
    }
  };

  useEffect(() => {
    const fetchUpiId = async () => {
      try {
        const response = await axios.get(
          `${apiConfig.baseUrl}${apiConfig.GetBankAllDetails}`
        );
        const bankData = response.data.data;
        if (bankData.length > 0) {
          setUpiId(bankData[0].UpiId);
          setBankDetails(bankData[0]);
       
        }
      } catch (err) {
        console.error("Error fetching bank details:", err);
      }
    };

    fetchUpiId();
  }, []);

  const offset = currentPage * ordersPerPage;
  const currentOrders = filteredOrders.slice(offset, offset + ordersPerPage);
  const pageCount = Math.ceil(filteredOrders.length / ordersPerPage);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

 

  const downloadShippingLabel = async (order, bankData = {}) => {
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.width; 
      const pageHeight = pdf.internal.pageSize.height;

      const loadImage = (src) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = src;
          img.onload = () => resolve(img);
          img.onerror = (err) => reject(err);
        });
      };

      const img = await loadImage(logoImage);
      const logoWidth = 50;
      const logoHeight = 20;
      const logoX = pageWidth - logoWidth - 10; 
      const logoY = 5; 
      pdf.addImage(img, "PNG", logoX, logoY, logoWidth, logoHeight);
      const createdAtDate = new Date(order.createdAt).toLocaleDateString(
        "en-GB",
        {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }
      );

      const orderInfoX = 10;
      let currentYPosition = logoY + 5;

      pdf.setFont("helvetica", "bold");
      pdf.text(`Order ID: ${order.orderID}`, orderInfoX, currentYPosition);
      currentYPosition += 7;
      pdf.text(`Date: ${createdAtDate}`, orderInfoX, currentYPosition);

      pdf.setDrawColor(100, 100, 100);
      pdf.setLineWidth(0.5);
      pdf.line(8, currentYPosition + 10, pageWidth - 10, currentYPosition + 10);
      currentYPosition += 20; 

      const addressX = 10; 
      let addressY = currentYPosition - 3;


      const shipByX = addressX + 163; 

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(12);
      pdf.text("Ship To", addressX, addressY); 

      addressY += 5;

      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(11);

      pdf.text(`Name: ${order.address?.name || "N/A"}`, addressX, addressY);
      addressY += 6; 

      const locationCityState = `${order.address?.location || "N/A"}, ${
        order.address?.city || "N/A"
      }, ${order.address?.state || "N/A"}, ${order.address?.pincode || "N/A"}`;
      pdf.text(`Address: ${locationCityState}`, addressX, addressY);
      addressY += 6;

      pdf.text(`Phone: ${order.address?.phone || "N/A"}`, addressX, addressY);
      addressY += 6;

      pdf.setDrawColor(0, 0, 0);
      pdf.setLineWidth(0.5); 
      pdf.line(10, addressY, pageWidth - 10, addressY); 

      pdf.setFont("helvetica", "bold"); 
      pdf.setFontSize(12);
      let shipByY = currentYPosition + 3; 
      pdf.text("Ship By", shipByX, shipByY);
      shipByY += 8; 

      pdf.setFont("helvetica", "normal"); 
      pdf.text("Bharat Cod", shipByX, shipByY);
      shipByY += 10; 

      currentYPosition = shipByY + 5;

      let initialTotalPrice = 0;
      let totalShippingCost = order.shippingCost || 0;
     
      const couponDiscount = order.items.reduce((total, item) => {
        return total + (item.couponDiscount || 0); 
      }, 0);

      const productRows = order.items.map((item, index) => {
        const unitPrice = item.price || 0;
        const quantity = item.quantity || 0; 
        const totalPrice = unitPrice * quantity;

        initialTotalPrice += totalPrice; 

        return [
          item.title || "N/A",
          quantity || "N/A",
          unitPrice.toFixed(2) || "N/A", 
          item.taxablevalue || "0",
          item.cgst || "0",
          item.sgst || "0",
          totalPrice.toFixed(2) || "",
        ];
      });

      const finalTotalPrice = order.totalPrice + order.shippingCost;

      pdf.setFont("helvetica", "bold");

      pdf.autoTable({
        startY: currentYPosition,
        head: [
          [
            "Title",
            "Qty",
            "Unit Price",
            "Taxable Value",
            "CGST",
            "SGST",
            "Total Price",
          ],
        ],
        body: productRows,
        theme: "grid",
        styles: { fontSize: 10 },
        headStyles: {
          fillColor: [240, 240, 240],
          fontStyle: "bold",
          textColor: 0,
        },
      });

      currentYPosition = pdf.autoTable.previous.finalY + 10;

      pdf.autoTable({
        startY: currentYPosition,
        head: [["Description", "Amount"]],
        body: [
          ["Initial Total Price", `${initialTotalPrice.toFixed(2)}`],
          ["Shipping Cost", `${totalShippingCost.toFixed(2)}`],
          ["Coupon Discount", `${couponDiscount.toFixed(2)}`],
          [
            "Final Total Price (Including Shipping)",
            `${finalTotalPrice.toFixed(2)}`,
          ],
        ],
        theme: "grid",
        styles: { fontSize: 12 },
        headStyles: {
          fillColor: [240, 240, 240],
          fontStyle: "bold",
          textColor: 0,
        },
      });

      currentYPosition = pdf.autoTable.previous.finalY + 10;

      const bankDetailsX = 10;
      const bankDetailsY = currentYPosition;

      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(10);

      pdf.text(
        `Bank Name: ${bankDetails?.BankName || "N/A"}`,
        bankDetailsX,
        currentYPosition
      );
      currentYPosition += 6;
      pdf.text(
        `IFSC Code: ${bankDetails?.IfscCode || "N/A"}`,
        bankDetailsX,
        currentYPosition
      );
      currentYPosition += 6;
      pdf.text(
        `Account Number: ${bankDetails?.AccountNumber || "N/A"}`,
        bankDetailsX,
        currentYPosition
      );
      currentYPosition += 6;
      pdf.text(
        `Account Holder Name: ${bankDetails?.AccountHolderName || "N/A"}`,
        bankDetailsX,
        currentYPosition
      );
      currentYPosition += 6;
      pdf.text(
        `UPI ID: ${bankDetails?.UpiId || "N/A"}`,
        bankDetailsX,
        currentYPosition
      );

      const qrCodeURL = `upi://pay?pa=${
        bankDetails?.UpiId
      }&am=${finalTotalPrice.toFixed(2)}&cu=INR`;
      const qrCodeCanvas = document.createElement("canvas");
      await QRCode.toCanvas(qrCodeCanvas, qrCodeURL);
      const qrCodeImage = qrCodeCanvas.toDataURL("image/png");

      const qrCodeWidth = 30;
      const qrCodeHeight = 30; 
      const qrCodeX = pageWidth - qrCodeWidth - 10;
      const qrCodeY = bankDetailsY - 5;

      pdf.addImage(
        qrCodeImage,
        "PNG",
        qrCodeX,
        qrCodeY,
        qrCodeWidth,
        qrCodeHeight
      );

      pdf.save(`Shipping_Label_${order.orderID}.pdf`);
    } catch (error) {
      console.error("Error generating the shipping label:", error);
    }
  };

  return (
    <div>
      <BackButton />
      <div className="filters">
        <label>
          Filter by Order ID:
          <input
            type="text"
            value={filterOrderId}
            onChange={(e) => setFilterOrderId(e.target.value)}
          />
        </label>
       
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            padding: "20px",
          }}
        >
          <DropdownOfStatus />
        </div>
        <div>
          <button
            onClick={handleNavigate}
            style={{
              backgroundColor: "#007BFF",
              color: "white",
              border: "none",
              padding: "10px 20px",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "background-color 0.3s",
            }}
          >
            Order Track and Update
          </button>
        </div>
        <div style={{ textAlign: "right" }}>
         
          <button
            onClick={handleRefresh}
            style={{
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              backgroundColor: "#28A745",
              color: "#fff",
              fontSize: "16px",
              cursor: "pointer",
              margin: "0 20px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              transition: "background-color 0.3s ease",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#218838")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor = "#28A745")
            }
          >
            Refresh Data
          </button>
        </div>
      </div>
      <div ref={tableRef}>
        <h1> List Of Accepted Order</h1>
        <table>
          <thead>
            <tr>
              <th>Items</th>

              <th> Product Price</th>
              <th>Shipping Price</th>
              <th>Coupon Discount</th>

              <th>Total Amount</th>
              <th>Order date</th>
              <th>Order ID</th>
              <th>Delivery Address</th>
              <th>Payment Status</th>
              <th>Payment Mode</th>

              <th>Status</th>
              <th>User ID</th>
              <th>Actions Change Product status</th>
              <th>Shipping label download</th>
            </tr>
          </thead>
          <tbody>
            {currentOrders.map((order) => (
              <tr key={order._id}>
                <td>
                  <table className="sub-table">
                    <thead>
                      <tr>
                        <th>Product ID</th>
                        <th>Product Name</th>
                        <th>Quantity</th>
                        <th> Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {order.items.map((item) => {
                        return (
                          <tr key={item._id}>
                            <td>
                              {item?.variation?.variationId
                                ? item?.variation?.variationId
                                : item.productId || "N/A"}
                            </td>
                            <td>
                              {item?.variation?.variationTitle
                                ? item?.variation?.variationTitle
                                : item.title || "N/A"}
                            </td>
                            <td>{item.quantity}</td>
                            <td>₹{item.totalPrice}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </td>
                {/* <td>₹{order.shippingCost ?? 0}</td> */}
                {/* <td>₹{order.totalPrice ?? 0}</td>
                <td>₹{(order.totalPrice ?? 0) + (order.shippingCost ?? 0)}</td> */}
                {order.items.map((item, index) => {
                  const productPrice = item.totalPrice || 0;
                  const variationPrice = item.variation?.VariationPrice || 0;

                  let totalPrice = productPrice;
                  if (item.productId && item.variation) {
                    totalPrice += variationPrice;
                  }

                  return (
                    <tr key={index}>
                      <td>₹{item.totalPrice}</td>
                    </tr>
                  );
                })}

                <td>₹{order.shippingCost ?? 0}</td>

                {order.items.map((item, index) => (
                  <tr key={index}>
                    <td>₹{item.couponDiscount}</td>
                  </tr>
                ))}

                <td>₹{(order.totalPrice ?? 0) + (order.shippingCost ?? 0)}</td>

                <td>
                  {new Date(order.createdAt).toLocaleDateString()}
                  <br />
                  {new Date(order.createdAt).toLocaleTimeString()}
                </td>
                <td>{order.orderID}</td>

                <td>
                  {order.address ? (
                    <>
                      <div>Name: {order.address.name || "N/A"}</div>
                      <div>Address: {order.address.location || "N/A"}</div>
                      <div>{order.address.city || "N/A"}</div>
                      <div>{order.address.state || "N/A"}</div>
                      <div>{order.address.pincode || "N/A"}</div>
                      <div>Phone: {order.address.phone || "N/A"}</div>
                      <div>Email: {order.address.email || "N/A"}</div>
                      <div>
                        Delivery Days: {order.address.deliveryDays || "N/A"}
                      </div>
                    </>
                  ) : (
                    "Address information is not available"
                  )}
                </td>
                <td>{order.paymentStatus}</td>
                <td>{order.paymentMode}</td>
                
                <td>{order.status}</td>
                <td>{order.userId}</td>
                <td>
                  {order.status !== "delivered" && (
                    <>
                      <select
                        value={newStatus}
                        onChange={(e) => setNewStatus(e.target.value)}
                      >
                        <option value="">Select Status</option>
                        <option value={getNextStatus(order.status)}>
                          {getNextStatus(order.status)}
                        </option>
                      </select>
                      <button
                        style={{
                          padding: "1px 2px",
                          fontSize: "15px",
                          fontWeight: "bold",
                          color: "white",
                          backgroundColor: "green",
                          border: "none",
                          borderRadius: "5px",
                          cursor: loading ? "not-allowed" : "pointer",
                          margin: "5px",
                          opacity: loading ? 0.6 : 1,
                          transition: "background-color 0.3s ease",
                        }}
                        onClick={() => {
                          setSelectedStatus(order.status);
                          handleStatusChange(order.orderID);
                        }}
                      >
                        Update Status
                      </button>
                    </>
                  )}
                </td>
                <td>
                  <button
                    onClick={() => downloadShippingLabel(order)}
                    style={{
                      padding: "8px 16px",
                      border: "none",
                      borderRadius: "6px",
                      background: "linear-gradient(90deg, #28A745, #34D058)",
                      color: "#ffffff",
                      fontSize: "14px", 
                      fontWeight: "bold",
                      cursor: "pointer",
                      margin: "8px", 
                      boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.15)",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "scale(1.03)";
                      e.target.style.boxShadow =
                        "0px 5px 10px rgba(0, 0, 0, 0.25)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "scale(1)";
                      e.target.style.boxShadow =
                        "0px 3px 6px rgba(0, 0, 0, 0.15)";
                    }}
                  >
                    Download PDF
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ReactPaginate
        previousLabel={"previous"}
        nextLabel={"next"}
        breakLabel={"..."}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        activeClassName={"active"}
      />
      {showModal && (
        <div className="modal ">
          <p style={{ color: "green" }}>{modalMessage}</p>
          <button onClick={() => setShowModal(false)}>Close</button>
        </div>
      )}
    </div>
  );
};

export default Accepted;
